import $$ from '@/store/plugins/storage'

const namespace = 'user'
$$.setNamespace(namespace)

const state = {
  user: $$.get('user') || {},
  // user: $$.get(namespace + '/user') || ''
  isDisabledFunc: false,
  versionMsg: {}
}

const getters = {
  User: state => state.user
}

const mutations = {
  _user (state, value) {
    state.user = value
  },
  _isDisabledFunc (state, value) {
    state.isDisabledFunc = value
  },
  _versionMsg (tate, value) {
    state.versionMsg = value
  }
}

const actions = {
  _User ({ commit }, value) {
    commit('_user', value)
  }
}

export default { namespaced: true, state, mutations, getters, actions }



// WEBPACK FOOTER //
// ./src/store/modules/user.js